var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"align-middle",style:(`display:inline-block; color: currentColor; mask: url(${_vm.path}) no-repeat center;`)},[_c('div',{style:(`color: currentColor; background: currentColor; width:${_vm.size}px; height:${_vm.size}px;`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }